import { isPerProductFieldType } from '../../events/is-per-product-field-type.js';
export function refineProductSummaryColumns(data, context) {
    const hasColumn = data.fields.some((field) => isPerProductFieldType(field.typeId));
    if (data.requiresProductSummary && !hasColumn) {
        context.addIssue({
            code: 'custom',
            message: 'Add at least one per-product field, or turn off Require Product Summary.',
            path: ['fields'],
        });
    }
    if (!data.requiresProductSummary && hasColumn) {
        context.addIssue({
            code: 'custom',
            message: 'Remove the per-product fields, or turn on Require Product Summary.',
            path: ['fields'],
        });
    }
}
//# sourceMappingURL=refine-product-summary-columns.js.map